var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "not-the-same-wrapper"
  }, [_c('div', {
    staticClass: "steps-container"
  }, [_c('div', {
    staticClass: "step step-0"
  }, [_c('img', {
    staticClass: "substep",
    attrs: {
      "id": "image-0",
      "src": _vm.imageLeftSrc,
      "alt": ""
    }
  }), _vm._l(_vm.stepsLeft, function (step, stepIndex) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: stepIndex <= _vm.progress.stepIndex,
        expression: "stepIndex <= progress.stepIndex"
      }],
      key: stepIndex
    }, [_c('blinking-cursor-text', {
      key: stepIndex,
      attrs: {
        "id": ("step-" + stepIndex),
        "text": step.answer,
        "text-step": stepIndex,
        "class-name": 'type-line title'
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "step step-1"
  }, [_c('img', {
    staticClass: "substep",
    attrs: {
      "id": "image-1",
      "src": _vm.imageRightSrc,
      "alt": ""
    }
  }), _vm._l(_vm.stepsRight, function (step, stepIndex) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.stepsLeft.length + stepIndex <= _vm.progress.stepIndex,
        expression: "stepsLeft.length + stepIndex <= progress.stepIndex"
      }],
      key: stepIndex
    }, [_c('blinking-cursor-text', {
      key: _vm.stepsLeft.length + stepIndex,
      attrs: {
        "id": ("step-" + (_vm.stepsLeft.length + stepIndex)),
        "text": step.answer,
        "text-step": _vm.stepsLeft.length + stepIndex,
        "class-name": 'type-line title'
      }
    })], 1);
  })], 2)])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }